import http from './http';

function handleError(error) {
  const resData = error?.response?.data;
  if (resData) {
    const msg = resData.message || error?.message || 'Request failed';
    const details = Array.isArray(resData.errors)
      ? resData.errors.map(e => (e.field ? `${e.field}: ${e.message}` : e.message)).join('; ')
      : (resData.error || '');
    const full = details ? `${msg} — ${details}` : msg;
    throw new Error(full);
  }
  throw new Error(error?.message || 'Request failed');
}

// GET /api/v1/hospital-settings
export async function getHospitalSettings() {
  try {
    const res = await http.get('/api/v1/hospital-settings');
    return { data: res.data?.data || res.data };
  } catch (e) { handleError(e); }
}

// POST /api/v1/hospital-settings
export async function createHospitalSettings(payload) {
  try {
    const res = await http.post('/api/v1/hospital-settings', payload);
    return { data: res.data?.data || res.data };
  } catch (e) { handleError(e); }
}

// PUT /api/v1/hospital-settings/{id}
export async function updateHospitalSettings(id, payload) {
  try {
    const res = await http.put(`/api/v1/hospital-settings/${id}`, payload);
    return { data: res.data?.data || res.data };
  } catch (e) { handleError(e); }
}

// DELETE /api/v1/hospital-settings/{id}
export async function deactivateHospitalSettings(id) {
  try {
    const res = await http.delete(`/api/v1/hospital-settings/${id}`);
    return { data: res.data?.data || res.data };
  } catch (e) { handleError(e); }
}

// PATCH /api/v1/hospital-settings/basic-info
export async function updateBasicInfo(payload) {
  try {
    const res = await http.patch('/api/v1/hospital-settings/basic-info', payload);
    return { data: res.data?.data || res.data };
  } catch (e) { handleError(e); }
}

// PATCH /api/v1/hospital-settings/invoice-config
export async function updateInvoiceConfig(payload) {
  try {
    const res = await http.patch('/api/v1/hospital-settings/invoice-config', payload);
    return { data: res.data?.data || res.data };
  } catch (e) { handleError(e); }
}

// PATCH /api/v1/hospital-settings/logo (expects FormData with file)
export async function updateHospitalLogo(file) {
  try {
    const formData = new FormData();
    formData.append('logo', file);
    
    const res = await http.patch('/api/v1/hospital-settings/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return { data: res.data?.data || res.data };
  } catch (e) { handleError(e); }
}

export const hospitalSettingsAPI = {
  getHospitalSettings,
  createHospitalSettings,
  updateHospitalSettings,
  deactivateHospitalSettings,
  updateBasicInfo,
  updateInvoiceConfig,
  updateHospitalLogo
};
